import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ViewportDetectionService } from '@finder/shared/services/viewport-detection/viewport-detection.service';
import { Subject } from 'rxjs';
import get from 'lodash-es/get';
import { CommonModule } from '@angular/common';
import { IntersectionDirective } from '@finder/shared/directives/intersection/intersection.directive';
import { LottieComponent } from '../lottie/lottie.component';
import { PictureComponent } from '../picture/picture.component';
import { AnchorComponent } from '../anchor/anchor.component';
import { FontIconComponent } from '../font-icon/font-icon.component';
import { SafeHtmlPipe } from '@finder/shared/utils/pipes/safe-html/safe-html.pipe';

@Component({
    selector: 'finder-timeline-image',
    templateUrl: './timeline-image.component.html',
    styleUrls: ['./timeline-image.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        IntersectionDirective, // finderIntersection
        LottieComponent,
        PictureComponent,
        AnchorComponent,
        FontIconComponent,
        SafeHtmlPipe,
    ]
})
export class TimelineImageComponent implements OnInit, OnDestroy {
    @Input() timelineData: any;

    enableParallax: boolean;
    intersecting = false;
    threshold = 0;

    private destroy$ = new Subject<void>();

    constructor(
        private viewport: ViewportDetectionService
    ) { }

    ngOnInit() {
        if (this.timelineData && this.timelineData.blocks && this.timelineData.blocks.length) {
            this.enableParallax = !get(this.timelineData, 'disableParallax', true);
            this.calculateThreshold();
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    setIntersection(ioEntry: IntersectionObserverEntry) {
        this.intersecting = this.viewport.isDesktop() && ioEntry.isIntersecting;
    }

    private calculateThreshold() {
        // calculate percentage
        const percentage = 100 / this.timelineData.blocks.length;
        // threshold are calculated using numeric ratios (1.0 means 100%)
        // see https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/thresholds
        const thresholdCalc = percentage / 100;
        // round the result to two decimals and parse to number
        this.threshold = +thresholdCalc.toFixed(2);
    }
}
